import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#phone-off-clip0_2249_1751)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M10.063 12.523 22.293.293a1 1 0 1 1 1.414 1.414L12.123 13.291q.855.748 1.813 1.359l.72-.721a3 3 0 0 1 3.164-.676q1.256.469 2.6.647A3 3 0 0 1 23 16.89v2.996a3 3 0 0 1-3.288 2.998 20.8 20.8 0 0 1-9.058-3.22 20.4 20.4 0 0 1-2.782-2.122l-6.165 6.165a1 1 0 0 1-1.414-1.414l9.6-9.6a1 1 0 0 1 .17-.17m.643 2.185-1.418 1.418q1.141 1.026 2.446 1.855a18.8 18.8 0 0 0 8.176 2.913A1 1 0 0 0 21 19.89v-3.01a1 1 0 0 0-.85-.999 14 14 0 0 1-3.032-.755 1 1 0 0 0-1.05.221l-1.27 1.27a1 1 0 0 1-1.202.162 17 17 0 0 1-2.89-2.07M5.734 13.65a1 1 0 0 0 .295-1.383 18.8 18.8 0 0 1-2.915-8.194A1 1 0 0 1 4.111 3H7.11c.512-.005.94.363 1.01.86.135 1.026.388 2.042.753 3.02a1 1 0 0 1-.224 1.057L7.383 9.203a1 1 0 1 0 1.414 1.414l1.27-1.27a3 3 0 0 0 .679-3.169 11.8 11.8 0 0 1-.645-2.589 3 3 0 0 0-3-2.589H4.11a3 3 0 0 0-2.986 3.27 20.8 20.8 0 0 0 3.227 9.084 1 1 0 0 0 1.383.295",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "phone-off-clip0_2249_1751" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }